import React from 'react';

// constants
import { EmployeeInformationColumnWidth, TimelineHours, TimelineColumnWidth } from '../../../../utils/timeline-constants';

// styling
import { Colors } from "_styles";

const TimelineHourRow = () => {
    return (
        <div style={{ display: 'flex', position: 'sticky', top: 0, minWidth: EmployeeInformationColumnWidth, maxWidth: EmployeeInformationColumnWidth }}>
            {/* employee information spacer (need to put space between area where employees list is and where clock should start) */}
            <div style={{ minWidth: EmployeeInformationColumnWidth, maxWidth: EmployeeInformationColumnWidth }} />
            {TimelineHours.map((hour, index) => (
                <div style={{ minWidth: TimelineColumnWidth, maxWidth: TimelineColumnWidth, border: '1px solid lightgrey', padding: 0, margin: 0 }} key={index}>
                    <p style={{ textAlign: 'center', color: Colors.PRM_LIGHT_BLUE, fontSize: '12px', fontWeight: 'bold', padding: 0, margin: 0 }}>{hour}</p>
                </div>
            ))}
        </div>
    );
};

export default TimelineHourRow;
